// tính kèo trên dưới châu á
export const getHandicapInfo = (handicapVal) => {
  if (!handicapVal) return { homeIsFavorite: false, awayIsFavorite: false, hasFavorite: false };
  
  const handicap = parseFloat(handicapVal);
  
  if (handicap > 0) {
    return { homeIsFavorite: true, awayIsFavorite: false, hasFavorite: true };
  }
  
  if (handicap < 0) {
    return { homeIsFavorite: false, awayIsFavorite: true, hasFavorite: true };
  }
  
  return { homeIsFavorite: false, awayIsFavorite: false, hasFavorite: false };
};
